var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 361,
    viewBox: "0 0 177 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 358C53.698 364.447 100.213 330.264 109.5 279C115.601 245.322 69.9177 225.964 84.5 195C99.5163 163.114 144.868 188.148 168.5 162C220.48 104.486 -79.5 12.5477 51 2",
    stroke: "#98DDD8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector5);
export default __webpack_public_path__ + "static/media/Vector 5.e1481723a1b153f10fd8b3bac1f8c1bd.svg";
export { ForwardRef as ReactComponent };